
export default function (url) {
  let options = getOption()
  return 'https://'+options.domen+'.fleetsoft.pro'+'/api' + url
}

export function getOption() {
  let options = { domen:'new', bgcolor: '#0f0' }
  const regex = /new\.fleetsoft\.pro/;
  const testregex = /test-new\.fleetsoft\.pro/;
  const devregex = /dev-new\.fleetsoft\.pro/;
  // options = { domen:'test-new', bgcolor: '#f00'}
  // options = { domen:'dev-new', bgcolor: '#f00'}
  // options = { domen:'test-new', bgcolor: '#f00'}
  // options = { domen:'slipkovskyi', bgcolor: '#f00'}
  // options = { domen:'new', bgcolor: '#0f0' }
  // options = { domen:'dev-new2', bgcolor: '#f00'}
  if (regex.test(window.location.href) && !testregex.test(window.location.href) && !devregex.test(window.location.href)) {
    options = { domen:'new', bgcolor: '#0f0' }
  }
  return options
}